import { render, staticRenderFns } from "./viewInfoFeedback.vue?vue&type=template&id=3c46a168&scoped=true&"
import script from "./viewInfoFeedback.vue?vue&type=script&lang=js&"
export * from "./viewInfoFeedback.vue?vue&type=script&lang=js&"
import style0 from "./viewInfoFeedback.vue?vue&type=style&index=0&id=3c46a168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c46a168",
  null
  
)

export default component.exports